import script from "./MainCompanies.vue?vue&type=script&setup=true&lang=js"
export * from "./MainCompanies.vue?vue&type=script&setup=true&lang=js"

import "./MainCompanies.vue?vue&type=style&index=0&id=8f75928c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f75928c"]])

export default __exports__